var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -1530)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(40 1530)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.089,11.617a.565.565,0,0,1-.4-.167L4.167,8.916a.576.576,0,0,1,0-.81.566.566,0,0,1,.8,0l2.119,2.13,5.042-5.07a.566.566,0,0,1,.8,0,.576.576,0,0,1,0,.81L7.492,11.45A.565.565,0,0,1,7.089,11.617Z",
    transform: "translate(41.449 1531.693)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.aac853f5d41938996205b91464db8158.svg";
export { ForwardRef as ReactComponent };